import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { SOURCES } from "utils/api/graphql/queries/sources";
import { SCREENS } from "utils/constants";
import View from "./View";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.SOURCES.LIST.path);
  const [updateSource] = useMutation(graphql.mutations.UPDATE_SOURCE, {
    refetchQueries: [
      {
        query: SOURCES,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.SOURCES.LIST.path);
    },
    onError: () => {},
  });
  const { data, loading, error } = useQuery(graphql.queries.SOURCE, {
    variables: { where: { id } },
  });
  const onSubmit = (data) => {
    return updateSource({
      variables: {
        where: {
          id,
        },
        data,
      },
    });
  };

  if (loading || error) return <Loading />;

  return <View onSubmit={onSubmit} data={data.source} cancel={cancel} />;
};

export default Detail;
